"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _useIsomorphicLayoutEffect = _interopRequireDefault(require("../useIsomorphicLayoutEffect"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var defaultRect = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var useMeasure = function useMeasure(target) {
  var observerRef = (0, _react.useRef)();
  var _a = (0, _react.useState)(function () {
      if (target) {
        return target.getBoundingClientRect();
      } else {
        return defaultRect;
      }
    }),
    rect = _a[0],
    setRect = _a[1];
  var handleOnResize = (0, _react.useCallback)(function (entries) {
    requestAnimationFrame(function () {
      if (Array.isArray(entries) && entries.length) {
        if (entries[0]) {
          setRect(entries[0].contentRect);
        }
      }
    });
  }, []);
  (0, _useIsomorphicLayoutEffect.default)(function () {
    var observer = observerRef.current;
    if (target) {
      if (!observer) {
        observerRef.current = new ResizeObserver(handleOnResize);
        observer = observerRef.current;
      }
      observer.observe(target);
    }
    return function () {
      observer === null || observer === void 0 ? void 0 : observer.disconnect();
    };
  }, [target, handleOnResize]);
  var handleRevalidate = (0, _react.useCallback)(function () {
    if (target) {
      setRect(function () {
        return target.getBoundingClientRect();
      });
    }
  }, [target]);
  return {
    rect: rect,
    revalidate: handleRevalidate
  };
};
var _default = useMeasure;
exports.default = _default;